import { render, staticRenderFns } from "./ExtendedContactInfo.vue?vue&type=template&id=1476a279&"
import script from "./ExtendedContactInfo.vue?vue&type=script&lang=js&"
export * from "./ExtendedContactInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports